import { FC } from 'react';
import classNames from 'classnames';

interface IIcon {
  icon: any;
  className?: string;
  onClick?: () => void;
}

const Icon: FC<IIcon> = ({ className, onClick, icon }) => {
  return (
    <div className={classNames('icon-container', [className])} onClick={onClick}>
      {icon}
    </div>
  );
};

export default Icon;
